import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Button, Input, Icon } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import { titles } from '@pages/GeneralRequest/Utils/settings'
import { commissions, mentors } from '@services/api'
import {
    editPopupFirstRow,
    editPopupSecondRow,
    editPopupSums,
    input_element,
    unsetMargin,
    red
} from '@pages/AgentCommissions/Reports/style.scss'

@inject((store: any) => {
    const { popupStore, authStore } = store
    return { popupStore, authStore }
})
@observer
export default class AddBudgetRow extends Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            //
            agent_name: null,
            agent_id: null,
            agent_search_id: null,
            //
            client_name: null,
            client_id: null,
            client_search_id: null,
            //
            amount: null,
            title: null,
            description: null,
            mentor_id: null
        }
    }

    componentDidMount(): void {
        const {
            events
        } = this.props
        this.setState({ mentor_id: events.state.mentor_id })
    }

    closePopup = reload => {
        const {
            popupStore: { togglePopup },
            events
        } = this.props
        events.setState({ createData: false, loading: false }, () => {
            if (typeof reload === 'boolean') events.getMentorsBudget()
            togglePopup('')
        })
    }

    onUserSearch = (e, searchId, keyName, keyId, isAgent) => {
        this.setState({ [searchId]: e.value.replace(/[^0-9]/g, '') }, () => {
            if (!this.state[searchId]) this.setState({ [keyName]: null })
            if (this.state[searchId] && e.value.replace(/[^0-9]/g, ''))
                commissions
                    .findUserForCommission({ id: this.state[searchId], isAgent })
                    .then(({ data, status }) => {
                        if (status === 201) return this.setState({ [keyName]: data.name, [keyId]: null })
                        if (status === 200) this.setState({ [keyName]: data.name, [keyId]: data.id })
                    })
                    .catch(() => alert('אירעה שגיאה'))
        })
    }

    onTextArea = (event, key) => this.setState({ [key]: event.value })
    onNumberInput = (event, key) => this.setState({ [key]: event.value[0] != 0 ? event.value.replace(/[^0-9]/g, '') : '' })

    onRowSave = () => {
        this.setState({ loading: true })
        mentors
            .createMentorsBudgetRow(this.state)
            .then(res => this.closePopup(true))
            .catch(err => alert('אירעה שגיאה'))
            .finally(() => this.setState({ loading: false }))
    }

    render() {
        const {
            popupStore: { popupType },
            events
        } = this.props
        // prettier-ignore
        const { agent_search_id, agent_id, agent_name, client_search_id, client_id, client_name, amount, title, loading, description } = this.state
        // prettier-ignore
        const { closePopup, onTextArea, onRowSave, onUserSearch, onNumberInput  } = this
        const { accepted_sum } = events.state
        const btnInner = loading ? <Icon type="loading" /> : titles.confirm
        const isAccepted = !(amount && accepted_sum - amount >= 0 && agent_name && title && description)
        const isMinus = accepted_sum - amount < 0

        return (
            <Modal title={`יצירת חיוב`} visible={popupType === 'addBudgetRow'} onCancel={closePopup} footer={null}>
                {/* search agent/client line */}
                <div className={editPopupSecondRow} style={{ width: '100%' }}>
                    <div className={editPopupSums}>
                        <div>מזהה סוכן</div>
                        <Input
                            className={`${input_element} ${unsetMargin}`}
                            value={agent_search_id}
                            onInput={({ target }) =>
                                onUserSearch(target, 'agent_search_id', 'agent_name', 'agent_id', true)
                            }
                        />
                    </div>
                    {agent_id ? <Icon type={'check'} style={{ color: 'green', marginTop: '20px' }} /> : null}
                    <div className={editPopupSums}>
                        <div>שם סוכן</div>
                        <Input
                            placeholder={agent_name}
                            style={{ width: '290px' }}
                            className={`${input_element} ${unsetMargin}`}
                            disabled={true}
                        />
                    </div>
                </div>
                {/* search agent/client line */}
                <div className={editPopupSecondRow} style={{ width: '100%' }}>
                    <div className={editPopupSums}>
                        <div>מזהה לקוח</div>
                        <Input
                            className={`${input_element} ${unsetMargin}`}
                            value={client_search_id}
                            onInput={({ target }) =>
                                onUserSearch(target, 'client_search_id', 'client_name', 'client_id', null)
                            }
                        />
                    </div>
                    {client_id ? <Icon type={'check'} style={{ color: 'green', marginTop: '20px' }} /> : null}
                    <div className={editPopupSums}>
                        <div>שם לקוח</div>
                        <Input
                            placeholder={client_name}
                            style={{ width: '290px' }}
                            className={`${input_element} ${unsetMargin}`}
                            disabled={true}
                        />
                    </div>
                </div>
                {/* date/budget line */}
                <div className={editPopupFirstRow} style={{ margin: '10px 0', width: '324px' }}>
                    <div className={editPopupSums}>
                        <div>{'סכום לחיוב'}</div>
                        <Input
                            className={`${input_element} ${unsetMargin}`}
                            value={amount}
                            maxLength={4}
                            onInput={({ target }) => onNumberInput(target, 'amount')}
                        />
                    </div>
                    {amount ? (
                        <Icon
                            type={`${isMinus ? 'close' : 'check'}`}
                            style={{ color: `${isMinus ? 'red' : 'green'}`, marginTop: '20px' }}
                        />
                    ) : null}
                    <div className={editPopupSums}>
                        <div>{'תקציב שנותר'}</div>
                        <Input
                            className={`${input_element} ${unsetMargin} ${isMinus ? red : ''}`}
                            placeholder={amount ? accepted_sum - amount : accepted_sum}
                            disabled={true}
                        />
                    </div>
                </div>
                {/* budget title line */}
                <div style={{ marginBottom: '15px' }}>
                    <div>{'נושא'}</div>
                    <TextArea rows={1} value={title} onInput={({ target }) => onTextArea(target, 'title')} />
                </div>
                {/* budget description line */}
                <div style={{ marginBottom: '15px' }}>
                    <div>{'פירוט'}</div>
                    <TextArea
                        rows={2}
                        value={description}
                        onInput={({ target }) => onTextArea(target, 'description')}
                    />
                </div>
                {/* save/cancel commission btn line */}
                <div style={{ marginTop: '20px' }}>
                    <Button disabled={isAccepted} type="primary" onClick={onRowSave}>
                        {btnInner}
                    </Button>
                    <Button onClick={closePopup}>ביטול</Button>
                </div>
            </Modal>
        )
    }
}
